import { LoginOutlined } from '@ant-design/icons';

const systemAuth = {
  id: 'groupc-authorization',
  title: 'System (Admin Panel)',
  type: 'group',
  children: [
    {
      id: 'system-authentication',
      title: 'Authentication',
      type: 'collapse',
      icon: LoginOutlined,
      children: [
        {
          id: 'users',
          title: 'System Users',
          type: 'item',
          url: '/users',
        },
        {
          id: 'roles',
          title: 'System Roles',
          type: 'item',
          url: '/roles',
        },
      ],
    },
  ],
};

export default systemAuth;
